import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import DeleteConfirmPopup from '../Common/DeleteConfirmPopup';
import TagPopup from '../Common/TagPopup/TagPopup';
import { getTags } from '../../actions/tags/getTags';
import { confirmDeletingTag, cancelDeletingTag, tagDelete } from '../../actions/tags/tagDelete';
import {
  editingTag,
  cancelEditingTag,
  editTag,
  creatingTag,
  createTag,
} from '../../actions/tags/tagEdit';
import {
  EATING_TAGS,
  DISH_TYPE_TAGS,
  CATEGORY_INGREDIENTS,
  TEMPLATE_PARAMETERS_TAG,
  VIDEO_TAGS,
} from '../../constants/appConstants';
import CategoryTagsGroup from './CategoryTagsGroup';

const categoryTagsInfo = [
  {
    name: 'Приёмы пищи:',
    categoryId: EATING_TAGS,
  },
  {
    name: 'Виды блюда:',
    categoryId: DISH_TYPE_TAGS,
  },
  {
    name: 'Категории продуктов:',
    categoryId: CATEGORY_INGREDIENTS,
  },
  {
    name: 'Параметры шаблона:',
    categoryId: TEMPLATE_PARAMETERS_TAG,
  },
  {
    name: 'Видео тренировок/саморазвития:',
    categoryId: VIDEO_TAGS,
  },
];

export const TagsList = ({
  getTags,
  creatingTag,
  tags,
  confirmDeletingTag,
  editingTag,
  showDeleteTagConfirmPopup,
  isShowTagPopup,
  tagDelete,
  deletingTagName,
  deletingTagId,
  cancelDeletingTag,
  isCreatingTagModalMode,
  cancelEditingTag,
  editingTagObj,
  editTag,
  createTag,
}) => {
  useEffect(() => {
    !tags.length && getTags();
  }, []);

  if (!Array.isArray(tags)) return null;

  return (
    <React.Fragment>
      <TagsWrapper>
        <MainTitle>
          <div />
          Теги
          <CreateButton onClick={creatingTag}>+</CreateButton>
        </MainTitle>
        {categoryTagsInfo.map((categoryTags) => (
          <CategoryTagsGroup
            key={categoryTags.categoryId + categoryTags.name}
            categoryId={categoryTags.categoryId}
            title={categoryTags.name}
            tags={tags.filter((tag) => tag.category_id === categoryTags.categoryId)}
            confirmDeletingTag={confirmDeletingTag}
            editingTag={editingTag}
          />
        ))}
        {showDeleteTagConfirmPopup && (
          <DeleteConfirmPopup
            isOpen={showDeleteTagConfirmPopup}
            title={`тег ${deletingTagName}`}
            onDelete={() => tagDelete(deletingTagId)}
            onCancel={cancelDeletingTag}
          />
        )}
        {isShowTagPopup && (
          <TagPopup
            isCreatingMode={isCreatingTagModalMode}
            editingTagObj={editingTagObj}
            cancel={cancelEditingTag}
            onEditTag={editTag}
            onCreateTag={createTag}
          />
        )}
      </TagsWrapper>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  const { tags } = state.getTags;
  const { deletingTagId, deletingTagName, showDeleteTagConfirmPopup } = state.tagDelete;
  const { isShowTagPopup, isCreatingTagModalMode, editingTagObj } = state.tagEdit;

  return {
    tags,
    deletingTagId,
    deletingTagName,
    showDeleteTagConfirmPopup,
    isShowTagPopup,
    isCreatingTagModalMode,
    editingTagObj,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getTags: () => {
      dispatch(getTags());
    },
    confirmDeletingTag: (id, name) => {
      dispatch(confirmDeletingTag(id, name));
    },
    cancelDeletingTag: () => {
      dispatch(cancelDeletingTag());
    },
    tagDelete: (id) => {
      dispatch(tagDelete(id));
    },
    editingTag: (tagObj) => {
      dispatch(editingTag(tagObj));
    },
    cancelEditingTag: () => {
      dispatch(cancelEditingTag());
    },
    editTag: (id, name) => {
      dispatch(editTag(id, name));
    },
    creatingTag: () => {
      dispatch(creatingTag());
    },
    createTag: (name, categoryId) => {
      dispatch(createTag(name, categoryId));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TagsList);

const MainTitle = styled.h1`
  font-size: 36px;
  line-height: 90px;
  height: 70px;
  margin: 0;
  box-sizing: border-box;
  text-align: center;
  cursor: pointer;
`;

const TagsWrapper = styled.div`
  width: 80%;
  position: relative;
  margin: 20px auto 0;
  border: 2px solid #c1c1c1;
  border-radius: 5px;
  box-shadow: 3px 3px 2px #afafaf;
  @media (max-width: 500px) {
    width: 96%;
  }
`;

const CreateButton = styled.div`
  position: absolute;
  width: 50px;
  height: 50px;
  right: 30px;
  top: 20px;
  box-sizing: border-box;
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  font-size: 32px;
  background: #5da834;
  color: #fff;
  border: none;
  border-radius: 5px;
  text-transform: uppercase;
  &:hover {
    background: #1b8100;
    border: 1px solid #000542;
  }
`;



// WEBPACK FOOTER //
// ./src/Components/Tags/TagsPage.jsx